import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, red } from '../colors';
import { GetThemeOptions } from '../../theme';
import { unityDarkTokens, unityLightTokens } from '@/theme/unityTokens';

export const errorColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityLightTokens['--status-error-color-main'],
          highContrast: unityLightTokens['--status-error-color-high-contrast'],
          lowContrast: unityLightTokens['--status-error-color-low-contrast'],
        }
      : {
          main: unityDarkTokens['--status-error-color-main'],
          highContrast: unityDarkTokens['--status-error-color-high-contrast'],
          lowContrast: unityDarkTokens['--status-error-color-low-contrast'],
        };
  }

  return mode === 'light'
    ? {
        main: red[600],
        highContrast: red[700],
        lowContrast: red[100],
      }
    : {
        main: red[500],
        highContrast: red[100],
        lowContrast: red[800],
      };
};
